module.exports = __webpack_public_path__ + "static/media/stocks-4.34e0dc32.jpg";